<template>
  <v-card>
    <div
      :class="[$vuetify.breakpoint.xs ? '': 'card-width', offre.isOffreAdherent ? (offre.isAbonnement ? 'card-border-green' : 'card-border-orange') : '']"
      class="d-flex flex-column px-5 py-4"
    >
      <div class="d-flex flex-row pb-5 justify-space-between">
        <v-chip
          v-if="offre.isAbonnement"
          color="var(--kaki)"
          label
        >
          <span class="action primary--text">
            Abonné
          </span>
        </v-chip>
        <v-chip
          v-else
          color="#FDEEE3"
          label
        >
          <span class="action --text-orange-dark">
            Non abonné
          </span>
        </v-chip>
        <v-icon
          v-if="offre.isOffreAdherent"
          :class="offre.isAbonnement ? 'primary--text' : '--text-orange-dark'"
        >
          mdi-check-circle
        </v-icon>
      </div>
      <span class="intro --text-grey-dark pb-5">{{ offre.sousTitre }}</span>
      <div class="d-flex justify-center pb-5">
        <v-img
          :src="pathPictogramme"
          class="ma-2"
          max-width="160"
        />
      </div>
      <div class="d-flex flex-row pb-4 justify-space-between">
        <div class="d-flex flex-column">
          <span class="titre-h4 secondary--text pb-2">Prix annuel</span>
          <div class="texte texte-gris-fonce">
            {{ sousTitreTarif }}
          </div>
        </div>
        <div class="d-flex flex-column tarif ml-1">
          <span
            v-if="!offre.isAbonnement"
            class="titre-h1 secondary--text"
          >
            Gratuit
          </span>
          <span
            v-if="offre.tarifTotal"
            class="titre-h4 secondary--text tarif-total"
          >
            {{ offre.tarifTotal }} €
          </span>
          <span
            v-if="offre.tarifAdherent"
            class="chiffre secondary--text"
          >
            {{ offre.tarifAdherent }} €
          </span>
        </div>
      </div>
      <div
        v-if="offre.isAbonnement && !offre.isOffreAdherent"
        class="d-flex flex-column justify-center pb-8"
      >
        <v-tooltip
          v-if="$roles.isUtilisateurAgrial() && !$roles.hasAllWriteAccess()"
          bottom
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <AgrButton
                class="pa-5"
                large
                block
                disabled
                @click="onClickSouscrireAbonnement"
              >
                <span class="action white--text pb-1">Souscrire à l'abonnement</span>
              </AgrButton>
            </div>
          </template>
          Vous n'avez pas les autorisations
        </v-tooltip>
        <AgrButton
          v-else
          class="pa-5"
          large
          block
          @click="onClickSouscrireAbonnement"
        >
          <span class="action white--text pb-1">Souscrire à l'abonnement</span>
        </AgrButton>
      </div>
      <div
        v-if="offre.isAbonnement"
        class="d-flex justify-space-between pb-5"
      >
        <span class="intro --text-grey-dark">Toutes les fonctionnalités non abonnées</span>
        <v-icon class="--text-branche">
          mdi-check
        </v-icon>
      </div>
      <div
        v-if="offre.isAbonnement"
        class="d-flex flex-column align-center"
      >
        <div class="d-flex flex-column align-center separator">
          <v-divider class="divider" />
          <!-- Permet d'effacer le v-divider derrière le bouton -->
          <v-icon
            class="backgroundButton"
            color="white"
            large
          >
            mdi-circle
          </v-icon>
        </div>
        <v-icon
          color="secondary"
          large
        >
          mdi-plus-circle
        </v-icon>
      </div>
      <div
        v-for="(contenu, index) in offre.contenus"
        :key="index"
      >
        <div class="d-flex flex-row justify-space-between py-4">
          <div class="d-flex flex-column justify-center pr-4">
            <span
              :class="offre.isAbonnement ? 'titre-h4 secondary--text' : 'intro texte-gris-fonce'"
              class="mb-2"
            >
              {{ contenu.sousTitre }}
            </span>
            <span
              v-if="offre.isAbonnement"
              class="texte texte-gris-fonce text-justify"
            >
              {{ contenu.description }}
            </span>
          </div>
          <div class="d-flex flex-row align-center">
            <v-icon class="--text-branche">
              mdi-check
            </v-icon>
          </div>
        </div>
        <v-divider v-if="index < offre.contenus.length - 1" />
      </div>
    </div>
    <v-dialog
      v-model="isOpenModalDemandeAbonnement"
      :fullscreen="$vuetify.breakpoint.mobile"
      width="500"
    >
      <DemandeAbonnementModal
        v-if="isOpenModalDemandeAbonnement"
        @close="isOpenModalDemandeAbonnement = false"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import {AgrButton} from '@agrial/ui'
import {mapActions} from 'vuex'
import DemandeAbonnementModal from '@/views/offre-abonnement/components/modal/demande-abonnement-modal.vue'

export default {
  name: 'OffreAbonnement',
  components: {DemandeAbonnementModal, AgrButton},
  props: {
    offre: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      isOpenModalDemandeAbonnement: false
    }
  },

  computed: {
    sousTitreTarif () {
      if (this.offre.isAbonnement && this.offre.tarifCoop) {
        return this.offre.tarifCoop + ' € prise en charge par la coopérative'
      } else {
        return 'Sans frais cachés'
      }
    },

    pathPictogramme () {
      if (this.offre.isAbonnement) {
        return '/images/pictogrammes/picto-info-abonnement.svg'
      } else {
        return '/images/pictogrammes/picto-info-abonnement-cadenas.svg'
      }
    }
  },

  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),

    onClickSouscrireAbonnement () {
      this.isOpenModalDemandeAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('DETAILS_ABONNEMENT')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-width {
  width: 400px;
}

.pictogramme {
  width: 160px;
}

.tarif {
  text-align: end;
  white-space: nowrap;
}

.tarif-total {
  text-decoration: line-through;
}

.separator {
  width: 100%;
  position: relative;
}

.divider {
  width: 350px;
  position: absolute;
  top: 17px;
}

.backgroundButton {
  position: absolute;
}

.card-border-orange {
  border: solid 3px var(--orange-dark);
  border-radius: 15px;
}

.card-border-green {
  border: solid 3px var(--branche);
  border-radius: 15px;
}
</style>
